import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { init } from '@chaseleto/sessions-sdk'

init('sk_fd039bb66fa4591039147da56fbe07162a717201415b891561c937f1e74e4e98', {
  endpoint: 'https://api.sessions.chxse.dev/api/v1/sessions',
  projectId: 'ForgeFair',
  attributes: {
    environment: 'production',
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 